module.exports = __webpack_public_path__ + "static/media/teygja_bakaefing_small.3f88096e.png";